import { Box, Grid, InputAdornment, TextField, Typography } from '@mui/material';
import React from 'react';
import moment from 'moment';
import CircularCounter from './CircularCounter';
import RouteChip from './RouteChip';
import RouteStopCategory from './RouteStopCategory';
import MinMaxTimePicker from '../../../components/MinMaxTimePicker';
import { newFoodTypes } from '../../../models/foodTypes';

const StopDetails = ({
  updateCategories,
  updateWeight,
  updatePickupBeginTime,
  updatePickupEndTime,
  isDonor = false,
  label = '',
  activeStep = 0,
  stopDetails = {},
}) => (
  <>
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <CircularCounter showPrimaryColor={isDonor} counter={activeStep + 1} size={38} fontSize={16} />
      <Box sx={{ ml: 1 }}>
        <Typography variant="body1" sx={{ fontWeight: 700, fontSize: '18px' }}>
          {label}
        </Typography>
        <RouteChip isDonor={isDonor} showIcon />
      </Box>
    </Box>

    <Box mt={2}>
      <Typography variant="body2" sx={{ fontWeight: 700 }}>
        Food Categories
      </Typography>
      <Typography variant="caption" color="GrayText">
        Select all that apply for this {isDonor ? 'pickup' : 'drop-off'}.
      </Typography>
      <Box>
        {newFoodTypes.map((type) => {
          const active = (stopDetails?.categories || []).find((category) => category === type.name);
          return (
            <RouteStopCategory
              active={active}
              key={type.name}
              name={type.name}
              label={type.label}
              onCategoryClick={() => updateCategories(type.name)}
            />
          );
        })}
      </Box>
      <Grid container spacing={1} sx={{ mt: 2 }}>
        <Grid item xs={6} sx={{ display: 'flex', flexDirection: 'column' }}>
          <Typography variant="body2" sx={{ fontWeight: 700 }}>
            Estimated Weight
          </Typography>
          <TextField
            value={stopDetails.weight}
            onChange={updateWeight}
            type="number"
            size="small"
            InputProps={{
              endAdornment: <InputAdornment position="end">lbs</InputAdornment>,
              min: 0,
              inputMode: 'numeric',
              pattern: '[0-9]*',
            }}
            sx={{ mt: 1 }}
          />
        </Grid>
        <Grid item xs={6} sx={{ display: 'flex', flexDirection: 'column' }}>
          <Typography variant="body2" sx={{ fontWeight: 700 }}>
            {isDonor ? 'Pickup Window' : 'Drop-off Window'}
          </Typography>
          <Box sx={{ display: 'flex', gap: 1, mt: 1 }}>
            <MinMaxTimePicker
              fullWidth
              label="From"
              inputVariant="outlined"
              size="small"
              maxTime={moment(stopDetails?.pickup_end, 'HH:mm:ss')}
              value={moment(stopDetails?.pickup_begin, 'HH:mm:ss')}
              onTimeChange={updatePickupBeginTime}
              data-testid="pickup_begin"
            />
            <MinMaxTimePicker
              fullWidth
              label="To"
              inputVariant="outlined"
              size="small"
              minTime={moment(stopDetails?.pickup_begin, 'HH:mm:ss')}
              value={moment(stopDetails?.pickup_end, 'HH:mm:ss')}
              onTimeChange={updatePickupEndTime}
              data-testid="pickup_end"
            />
          </Box>
        </Grid>
      </Grid>
    </Box>
  </>
);

export default StopDetails;
